var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoIdVerificationBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 17.5002C25 25.0002 19.75 28.7502 13.51 30.9252C13.1832 31.036 12.8283 31.0307 12.505 30.9102C6.25 28.7502 1 25.0002 1 17.5002V7.00025C1 6.60242 1.15804 6.22089 1.43934 5.93959C1.72064 5.65828 2.10218 5.50025 2.5 5.50025C5.5 5.50025 9.25 3.70025 11.86 1.42025C12.1778 1.14875 12.582 0.999573 13 0.999573C13.418 0.999573 13.8222 1.14875 14.14 1.42025C16.765 3.71525 20.5 5.50025 23.5 5.50025C23.8978 5.50025 24.2794 5.65828 24.5607 5.93959C24.842 6.22089 25 6.60242 25 7.00025V17.5002Z",
    fill: "#F2F2F2",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 12.2502L9.25 19.7502",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 12.2502L16.75 19.7502",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoIdVerificationBadge);
export default __webpack_public_path__ + "static/media/no-id-verification-badge.87d25be0366838a4c65db7627dd79a01.svg";
export { ForwardRef as ReactComponent };